'use strict';

angular.module('app').directive('dateFormat', function() {
  return {
    restrict: 'A',
    scope: {
      ngBind: '='
    },
    link: function(scope, element, attrs) {
      var localeLanguage = window.navigator.language;
      moment.locale(localeLanguage);
      scope.$watch('ngBind', function(oldVal, newVal) {
        if (newVal != oldVal) {
          scope.ngBind = moment(newVal).format('L');
        }
      });
    }
  };
});